{
  "title": "Профили шахсӣ",
  "info": "Маълумоти шахсӣ",
  "idCopy": "Нусхаи ID",
  "copied": "ID нусха шуд",
  "copyFailed": "Нусхабардории ID нашуд",
  "name": "Ном",
  "surname": "Насаб",
  "birth": "Санаи таваллуд",
  "gender": "Ҷинс",
  "chooseGender": "Ҷинсро интихоб кунед",
  "male": "Мард",
  "female": "Зан",
  "save": "Нигоҳ доштан",
  "saved": "Маълумот нигоҳ дошта шуд",
  "missing": "Ҳамаи маълумоти шахсиро пур кунед.",
  "failed": "Маълумот нигоҳ дошта нашуд.",
  "alreadySaved": "Маълумоти шахсӣ тасдиқ ва қулф шудааст.",
  "confirmTitle": "Тасдиқ кунед",
  "confirmText": "Дурустии маълумотро тасдиқ кунед. Баъдтар тағйир додан танҳо бо иҷозати маъмур мумкин аст.",
  "verify": "Тасдиқ",
  "back": "Бозгашт",
  "contacts": "Маълумоти тамос",
  "linked": "Пайваст",
  "notLinked": "Пайваст нест",
  "unverified": "Тасдиқ нашудааст",
  "manage": "Идора",
  "telegram": "Telegram",
  "unavailable": "Мавҷуд нест",
  "phone": "Телефон",
  "email": "Почтаи электронӣ",
  "change": "Дархости тағйир",
  "pending": "Дархост баррасӣ мешавад.",
  "requestTitle": "Тағйири маълумот",
  "changeHelp": "Тасдиқи маъмур лозим аст.",
  "reason": "Сабаби тағйир",
  "submit": "Ирсоли дархост",
  "noChanges": "Тағйир нест.",
  "changeFailed": "Дархост фиристода нашуд.",
  "changeSent": "Дархост ба маъмур фиристода шуд.",
  "support": "Тамос бо дастгирӣ",
  "age": "Санаи таваллудро дуруст ворид кунед.",
  "loggingOut": "Баромадан...",
  "logout": "Аз ҳисоб баромадан"
}
